export class Option {
  id: number;
  name: string;
  isDefault: boolean;
  isSelected: boolean;
}

export class newOption {
  id: number;
  value: string;
  label: string;
}
export class dropDownOption {
  selectedId: Option;
  selectedIds: Option[];
}

export class AssessmentMetric {
  id: number;
  lookupTypeId: number;
  name: string;
}
